module.exports = __webpack_public_path__ + "img/ring_r_i_null_1@2x.b6c24f1e.png";